'use client';

import { useEffect } from 'react';
import { startUserActivationTracking } from 'helpers/hooks/useUserActivation';

/**
 * Records the visitor's first gesture anywhere on the site, so that videos mounted later - on this
 * page or on any page reached from it - know they are allowed to start with sound.
 *
 * Renders nothing; it exists only to attach the listeners from the root layout, ahead of any
 * component that cares about the answer.
 */
export default function UserActivationTracker() {
  useEffect(() => {
    startUserActivationTracking();
  }, []);

  return null;
}
